import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { UtilitiesService } from '../services/utilities.service';
import { GoogleTagsService } from '../services/google-tags.service';
import { TranslatePipe } from  '../pipes/translate.pipe';
import * as _ from 'lodash';
import { healthPackageFlowType, PACKAGELOCATION } from '../app.type';
import { LinkPatientService } from '../services/link-patient.service';
import { PackageService } from '../services/package.service';
import * as AppConstant from '../app.string';
import { PaymentService } from '../services/payment.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { HEALTHPACKFILTER } from "../app.const";
import { getLinkedPatientLimitAlertContent, ReusableAlertPopupContent } from '../components/reusable-alert-popup/reusable-alert-popup.const';

@Component({
  selector: 'app-health-package-flow',
  templateUrl: './health-package-flow.component.html',
  styleUrls: ['./health-package-flow.component.scss']
})
export class HealthPackageFlowComponent {

  @Output() close: EventEmitter<any>;
  @Output() action: EventEmitter<any>;
  @Input() pkgdetails: any;
  @Input() selectedPackage: any;
  @Input() packageOpt: any;
  @Input() flowType: any;
  @Input() subsequentApptBooking: any;
  @Input() modeOfService: any;
  @Input() subserviceWithResource: any;
  @Input() isWellnessPackageCoupon: boolean = false;
  @Input() isMultiplePractCode: boolean = false;
  public state: healthPackageFlowType;
  public input: Object = {
    "selectedPkg": {},
    "selectedFacility": {},
    "selectedPatient": {},
    "selectedSlot": {},
    "selectedDirective": {},
    "modeOfService": {}
  };
  public index = 0;
  public linkedPatients: Array<any>;
  public isRegisterPatient: boolean;
  public isManageIdentities: boolean = false;
  public selectedPatient: any;
  public  selectedSlot: any;
  public requestInfo: any;
  private isBacktoConfirmReq: boolean;
  public reqConfirm: any;
  // flowType: 'OLD' | 'NEW' = 'NEW';
  public modeOfVisits: Array<PACKAGELOCATION>;
  public visitOptions: {};
  //undefined
  public selectedPatientWithAppt: any
  serviceCatagories: any;
  public isBookingSubService: boolean = false;;
  public canPay: boolean = false;
  public isReschedule: any;
  public choosenFacility: any;
  public selectedVisitType: any;
  public healthPkg: any;
  public apptConfirmDetails: any;
  public openBookAppointment: boolean = false;
  public swapPatient: boolean = false;
  public chargeVatInfo: any;
  public chargeVatDetails: any;
  public chargeDetails: any;
  public selectedServices: any;
  public pointsType: any;
  public isPayableService: boolean = false;
  public patientPayableApprox: any = 0;
  public couponAdditionalParams: any;
  public openConsultationTypeSelection: boolean = false;
  private consultResolve!: (value: string | null) => void;
  public consultationType: any;
  public bookSubsequentAppt: any;
  public options: any;
  public openHealthPkgs: boolean = false;
  public selections: any;
  public packageList: any;
  public gender: any;
  public genderList: Array<any>;
  public selectedGenderValue: any;
  public navOptions: any; 
  public hideHHCNav: any;
  public selectedDirective: any;
  public hideClinicOptFromModeOfService: boolean = false;
  public hideHomeVideoOptFromModeOfService: boolean = false;
  public applicableFilter: Array<any>;
  public showContactusModal: boolean = false;
  public showLinkedPatientLimitPopup: boolean = false;
  public linkedPatientLimitAlertContent: ReusableAlertPopupContent;
  constructor(private user: UserService, private util: UtilitiesService, private gtmService:GoogleTagsService, private translate: TranslatePipe, private linkPatService:LinkPatientService,  private cdf: ChangeDetectorRef,
    private packageService: PackageService, private paymentService:PaymentService, private router: Router) {
    this.close = new EventEmitter<any>();
    this.action = new EventEmitter<any>();
    this.linkedPatientLimitAlertContent = getLinkedPatientLimitAlertContent(this.translate);
  }

  ngOnInit(): void {
    if (this.pkgdetails) {
      this.checkOrderDetails();
    } else {
      const data = this.user.getUpdateInfoSync('directives');
    if (data) {
      this.serviceCatagories = data.userDefined.filter(def =>def.directiveGroup == 'HOSPSERV');
      if(this.serviceCatagories.length)
      this.input['selectedDirective'] = this.serviceCatagories[0];
    }
    this.state = 'LIST_PACKAGES';
    this.setLinkedPatients();
    this.isBookingSubService = this.user?.getIsBookingSubService() || false
    }
    if(this.flowType === 'BOOKSUBSERVICE') {
      this.healthPkg = this.packageService.getAllHpValues();
      // console.log('isBookingSubService', this.isBookingSubService, 'healthPkg', this.healthPkg);
      if(this.modeOfService === 'CON') {
        this.openBookAppointment = true;
        this.consultationType = this.healthPkg?.consultationType
      } else if(this.modeOfService === 'CLINIC') {
        this.packageService.setValue('selectedFacilityEvent', this.healthPkg?.choosenFacility);
        this.packageService.setValue('choosenFacility', this.healthPkg?.choosenFacility);
        let careElementType = this.healthPkg?.bookingForConcepts[0]?.careElementType;
        this.input['modeOfService'] = this.healthPkg?.selectedVisitType
        if(this.isMultiplePractCode) {
          this.openBookAppointment = true;
        } else
          this.index = 5;
      }
    }
    console.log('selectedPackage', this.selectedPackage, this.input);
    // if(this.selectedPackage && this.isWellnessPackageCoupon) 
    // this.toggleState({ data: this.selectedPackage, state: 'CHOOSE_PACKAGE', key: 'selectedPkg'} )
  }

  public async selectedFacility(event) {
    // console.log('selectedFacilityselectedFacility', event)
    this.choosenFacility = this.state = event.data;
    this.input[event.key] = event.data;
    this.packageService.setValue('selectedFacilityEvent', this.choosenFacility);
    this.packageService.setValue('choosenFacility', this.choosenFacility);
    this.healthPkg = this.packageService.getAllHpValues();

    let careElementType = this.healthPkg?.bookingForConcepts[0]?.careElementType;
    let { navState, consultationType } = await this.generateNavState(careElementType);
    this.packageService.setValue('consultationType', consultationType);
    this.packageService.setValue('careElementType', careElementType);
    this.packageService.setValue('careElementParams', navState.careElementParams);

    if (careElementType === 'CON') {
      let applicableSpecialities = this.choosenFacility?.controls?.applicableSpecialities;
      if (!applicableSpecialities || (Array.isArray(applicableSpecialities) && applicableSpecialities.length === 0)) {
        this.handleResourceBasedNavigation(navState);
        return;
      }
      let facilityId = this.choosenFacility?.facilityId;
      let facilityForConsultation = null;
      if (facilityId) {
        facilityForConsultation = this.user.getFacilityByFacilityId(facilityId)
      }
        let deeplink = { facility: facilityForConsultation, applicableSpecialities: applicableSpecialities }
        let options = {
          deeplink: deeplink,
          packageState: this.packageService.getAllHpValues()
        }
      switch (consultationType) {
        case 'HOSPITAL':
          this.bookSubsequentAppt = 'HOSPITAL'
          this.options = options;
          this.openBookAppointment = true;
          this.index = 5;
          break;
        case 'VIDEO':
          this.bookSubsequentAppt = 'VIDEO'
          this.options = options;
          this.openBookAppointment = true;
          this.index = 5;
          break;
      }
    } else {
      this.handleResourceBasedNavigation(event);
    }
  }

  public handleResourceBasedNavigation(event) {
    let resources = this.choosenFacility?.controls?.packageCalendarResourceCode;
      let resource = resources?.split(',') || []
      if(resource.length==1){
        this.choosenFacility.controls.packageCalendarResourceCode = resource[0]
        this.toggleState(event);
      }else if(resource.length>1){
        let allPractitioner = this.user.getAllPractitioners(false, true, ['HOSP', 'HOSPVIDEO']);
        let packageResource=resource.map((res,index)=>{
          let found=allPractitioner.find(pract => pract.resourceId == res)
          if(found){
            return found;
          }else{
            return {resourceId:res,index:index,showPractWithIdOnly:true,order:2}
          }
        })
        let packageResources = packageResource;
        this.packageService.setValue('packagePractResources', packageResources)
        // console.log('sanitizedState 23', packageResources, allPractitioner)
        const uniqueSpecialityIds = [...new Set(packageResource.map(p => p.specialityId))];

        if (this.choosenFacility?.controls) {
            this.choosenFacility.controls.applicableSpecialities = uniqueSpecialityIds;
            this.packageService.setValue('choosenFacility', this.choosenFacility);
        }
        this.openBookAppointment = true;
        this.isMultiplePractCode = true;
  }
  }

    private async generateNavState(careElementType) {
    let consultationType;
    if (careElementType === 'CON') {
      consultationType = await this.getConsultationType()
      if (!consultationType) return;
    }
    let navState = {
      selectedDirective: this.healthPkg?.selectedDirective,
      selectedPackage: this.selectedPackage,
      selectedFacilityId: this.healthPkg?.selectedFacilityId,
      choosenFacility: this.healthPkg?.choosenFacility,
      selectedPatient: this.selectedPatient,
      bookingForConcepts: this.healthPkg?.bookingForConcepts,
      selectedVisitType: this.selectedVisitType,
      packageIndicator: this.healthPkg?.packageIndicator,
      bookingApplicableFacilities: this.healthPkg?.bookingApplicableFacilities,
      careElementParams: {
        careElementType: careElementType,
        consultationType: consultationType
      },
      packageDefination: this.healthPkg?.packageDefination
    }
    // console.info('gennavState', this.bookingForConcepts)
    return { navState, consultationType }
  }

  public selectedPractitioner(event) {
    this.healthPkg = this.packageService.getAllHpValues();
    this.openBookAppointment = false;
    this.requestInfo = {
      appointmentType: this.healthPkg?.flowType,
      flowType: this.healthPkg?.classification,
      selectedDirective: this.healthPkg?.selectedDirective,
      selectedFacility: this.healthPkg?.choosenFacility,
      selectedPatient: this.healthPkg?.selectedPatient,
      selectedPkg: this.healthPkg?.selectedPackage,
      // selectedSlot: this.healthPkg?.selectedSlotFac,
      visitType: this.healthPkg?.selectedVisitType
    }
    this.index = 5;
    // this.toggleState(this.healthPkg?.selectedFacilityEvent);
  }


  public backToFacilitySelection() {
    if(this.isBookingSubService) {
      this.close.emit()
    } else {
      this.openBookAppointment = false;
      this.index = 4;
    }
  }




    private async getConsultationType() {
    let consultationType = this.getMappedConsultationType();
    if (consultationType === 'ALL' && this.healthPkg?.bookingForConcepts[0]?.careElementType === 'CON') {
      consultationType = await this.chooseConsultationType()
    }
    return consultationType;
    }

    private getMappedConsultationType() {
    let defaultConsultationType = this.selectedVisitType === 'CLINIC' ? 'HOSPITAL' : 'VIDEO';
    let keyNameForConsultationType = this.selectedVisitType === 'CLINIC' ? 'clinicConsultTypecode' : 'homecareConsultTypecode';
    let consultationType = ['HOSPITAL', 'VIDEO', "ALL"].includes(this.healthPkg?.firstService[keyNameForConsultationType]) ? this.healthPkg?.firstService[keyNameForConsultationType] : defaultConsultationType;
    return consultationType
  }

  public selectedHealthPackage(event) {
    this.selectedPackage = event.data;
    this.packageService.setValue('selectedPackage', this.selectedPackage);
    this.toggleState(event);
  }

  public selectedModeOfService(event) {
    this.selectedVisitType = event.data;
    this.packageService.setValue('selectedVisitType', this.selectedVisitType);
    this.toggleState(event);
  }

  public toggleState(event){
    this.healthPkg = this.packageService.getAllHpValues();
    this.state = event.state
    this.input[event.key] = event.data
    console.log('toggleState', this.state, this.input);
    if(this.state === 'CHOOSE_PACKAGE' && !this.isWellnessPackageCoupon) {
      this.input['flowType'] = this.flowType['options']['classification'];
    }
    if(this.input['selectedPkg']['careElementType'] === 'CON' && this.index == 3) {

    }
    if(this.isBacktoConfirmReq) {
      if(this.index == 4){
        this.setInpuForSlot();
        this.index = 5
      }else{
        this.generateConfirmReqParams();
        this.index = 6;
      }
      this.isBacktoConfirmReq = false;
    }
    else this.index++;

    if(this.index == 2){
      this.setInpuForSlot();
    }
  }

  public setInpuForSlot(){
    this.input['in'] = {
      facility: {
        id: this.input['selectedFacility']['facilityId']
      },
      speciality:{
        id: this.input['selectedFacility'].controls?.packageCalendarClinic,
      },
      practitioner: {
        id: this.input['selectedFacility'].controls?.packageCalendarResourceCode,
        availDays: this.input['selectedFacility'].controls?.daysAvailable
      }
    }
  }
  public checkAction(event){
    this.healthPkg = this.packageService.getAllHpValues();
    if(this.isBookingSubService || (this.isWellnessPackageCoupon && this.index === 1)) {
      this.close.emit()
    } else {
    if(event === 'BACK'){
      if (this.index === 1) {
        this.selectedPackage = null;
      }
      this.index--;
    }else{
      this.packageService.clearAllValues();
      this.close.emit(event)
    }
    }
  }

  public redirectToMyPackage(event) {
    this.action.emit(event)
  }

  public backToHome() {
    this.close.emit();
  }

  public pkgConfirm(event) {
    this.healthPkg = this.packageService.getAllHpValues();
    if(this.isBookingSubService) {
      this.generateSubserviceConfirmReqParams();
      this.index = 7;
    }
    else {
      this.input[event.key] = event.data;
      this.apptConfirmDetails = event.data;
      this.index = 7;
    }
  }

  private setLinkedPatients() {
    this.user.getUserInfo('linkedPatients').subscribe(data => {
      this.linkedPatients = data
      this.getMyPackages();
    });
    // this.user.getUserId().subscribe(data => {
    //   if (data) {
    //     this.linkPatService.getLinkedPatient(data).subscribe(result => {
    //       if (result.status === 'SUCCESS') {
    //         this.linkedPatients = result.data;
    //         this.getMyPackages();
    //       }
    //     })
    //   }
    // })
  }

  public choosePat(event){
    this.selectedPatient = event
  }

  public setSelectedPatient(event){
    let data = { data: event, state: 'CHOOSE_SLOT', key: 'selectedPatient'};
    this.packageService.setValue('selectedPatient', event);
    this.showModeOfService(event);
    if(!this.swapPatient) {
    this.toggleState(data);
    } else {
      this.previewProcess(data);
    }
  }

  public showModeOfService(event) {
    let modeOfVisits = this.translate.transform(this.input['selectedPkg'], 'MODEOFSERVICE');
    console.log('modeOfVisits', modeOfVisits);
    this.visitOptions = { modeOfVisits, patient: event, package: this.input['selectedPkg'] }
  }

  public setSlot(event){
    this.healthPkg = this.packageService.getAllHpValues();
    this.selectedSlot = event;
    if(this.isBookingSubService) {
      this.toggleState({ data: event, state: 'REVIEW', key: 'selectedSlot'} );
      this.generateSubserviceConfirmReqParams();
    } else {
      this.toggleState({ data: event, state: 'REVIEW', key: 'selectedSlot'} );
      this.generateConfirmReqParams();
    }
  }


  openModal(id: string) {
    this.gtmService.pushGTMEvent('Health Packages', 'step_option_select_person',{patient_type:'New'});

    if (id == 'isRegisterPatient' && this.user.canDisableRegister()) {
      this.showLinkedPatientLimitPopup = true;
      return;
    }

    this.isRegisterPatient = true;
  }

  public openContactUsModal() {
    this.showContactusModal = true;
  }

  public closeLinkedPatientLimitPopup() {
    this.showLinkedPatientLimitPopup = false;
  }

  public openContactUsFromLimitPopup() {
    this.closeLinkedPatientLimitPopup();
    this.openContactUsModal();
  }

  public openManageMyFamilyFromLimitPopup() {
    this.closeLinkedPatientLimitPopup();
    this.isManageIdentities = true;
  }

  public closeManageIdentity(status: boolean) {
    this.isManageIdentities = false;
    this.setLinkedPatients();
  }

  public getLinkedPatientLimit() {
    return this.user.getMaxLinkedPatientCount();
  }

  public canDisableRegister() {
    return this.user.canDisableRegister();
  }

  public closeRegPatient(ev){
    this.isRegisterPatient = false
    this.setLinkedPatients();
  }

  public getMyPackages(){ 
    let patientList = this.linkedPatients
    let tmp=[];
    patientList.forEach((p)=>{
      tmp.push(p['uhid']
      )
    })
    let inparam={
      "patientIds":tmp,
      "status":'A'
    }
    this.packageService.getPackages(inparam,true).subscribe(data=>{
      if(data.length>0){
      }
    })
  }

  public generateConfirmReqParams(){
    this.requestInfo = {
      "appointmentType": "HP",
      "flowType": this.input['flowType'],
      "visitType": this.input['modeOfService'],
      "selectedPkg": this.input['selectedPkg'],
      "selectedFacility": this.input['selectedFacility'],
      "selectedSlot": this.selectedSlot,
      "selectedPatient": this.input['selectedPatient'],
      "selectedDirective": this.input['selectedDirective'],
    }
  }

  public generateSubserviceConfirmReqParams() {
    this.requestInfo = {
      "appointmentType": "HP",
      "flowType": this.healthPkg?.classification,
      "visitType": this.healthPkg?.selectedVisitType,
      "selectedPkg": this.healthPkg?.selectedPackage,
      "selectedFacility": this.healthPkg?.choosenFacility,
      "selectedSlot": this.selectedSlot,
      "selectedPatient": this.healthPkg?.selectedPatient,
      "selectedDirective": this.healthPkg?.selectedDirective,
    }
    this.packageService.setValue('requestInfo', this.requestInfo)
  }
 
  public editAction(type){
    this.isBacktoConfirmReq = true;
    if(type == 'FACILITY'){
      this.index = 4
    }
    if(type == 'PATIENT' || type  == 'select_patient'){
      this.index = 2;
      this.swapPatient = true;
    }
    if(type == 'SLOT'){
      this.index = 5
    }
  }

  private checkOrderDetails() {
    let orderData = atob(this.pkgdetails);
    let arr = orderData.split('&');
    let params = {};
    for (var i = 0; i < arr.length; i++) {
      var pair = arr[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    this.paymentService.getTransactionDetail(params['orderid']).subscribe(data => {
      this.packageService.setValue('transactionDetail', data);
      // console.log('transactionDetail', data, this.packageService.getAllHpValues());
        if(data.status=='S'){
          this.requestInfo = JSON.parse(this.user.getStorage(AppConstant.HEALTHPKG_REQ))
          // this.openPkgReq =true;
          this.reqConfirm = {
            confirmReq : true,
            status:data.status,
            data: data
          }
          this.apptConfirmDetails = {
            patientId: data?.patientId ? data?.patientId : data?.transactionRequest?.patientId,
            patientName: data?.transactionRequest?.patientName,
            packageDetails: data?.transactionRequest?.packageDetails,
            facilityId: data?.facilityId ? data?.facilityId : data?.transactionRequest?.facilityId,
            apptDateTime: data?.response?.appointmentDateTime,
            paymentStatus: data?.response?.status || data?.status,
            status: data?.response?.status || data?.status,
            paymentData: data?.response,
            apptRefNumber: data?.response?.apptRefNumber,
            confirmReq : true,
          }
          this.user.setAppointmentRefNum(data?.response?.apptRefNumber);
          // console.log('apptConfirmDetails--', this.apptConfirmDetails,'reqConfirm', this.reqConfirm);
        } else if(data.status=='R' || data.status=='F' || data.status == 'P'){
          this.requestInfo = JSON.parse(this.user.getStorage(AppConstant.HEALTHPKG_REQ))
          // this.openPkgReq =true;
          this.reqConfirm = {
            confirmReq : true,
            status:data.status,
            data: data
          }
          this.apptConfirmDetails = {
            patientId: data?.patientId ? data?.patientId : data?.transactionRequest?.patientId,
            patientName: data?.transactionRequest?.patientName,
            packageDetails: data?.transactionRequest?.packageDetails,
            facilityId: data?.facilityId ? data?.facilityId : data?.transactionRequest?.facilityId,
            apptDateTime: data?.response?.appointmentDateTime,
            paymentStatus: data?.response?.paymentStatus,
            status: data?.response?.status,
            apptRefNumber: data?.response?.apptRefNumber,
            confirmReq : true,
          }
        }
        this.index = 7;
    })
  }


  public previewProcess(data) {
    this.getPageConfiguration();
    this.healthPkg = this.packageService.getAllHpValues();
    if (this.isBookingSubService) {
      this.canPay = false;
      this.proceedApptFlow(data);
      return;
    }
    if (!this.isReschedule) {
      if (this.input['modeOfService'] === 'CLINIC') {
        this.getPackageCharges(data);
      } else {
        // this.getHomecareCharges()
      }
    } else {
      this.proceedApptFlow(data);
    }
  }

  private getPageConfiguration() {
    let chosenFacility = this.healthPkg?.chosenFacility;
    this.isPayableService = false;
    let patientPayable = chosenFacility?.controls?.discountCharge || chosenFacility?.controls?.charge || null
    // if (this.selectedVisitType === 'CLINIC' && this.packageIndicator === 'ORDERSET') {
      // if (this.user.getPaymentGateway && this.user.canPayForService('serviceswithorder') && this.chosenFacility?.controls?.payableOnline === 'true') {
        this.isPayableService = true;
      // }
    // } else {
      // this.isPayableService = true;
    // }
    if (!this.isPayableService) {
      this.patientPayableApprox = patientPayable;
    }
    this.couponAdditionalParams = {
      package: this.selectedPackage,
      patient: this.selectedPatient,
      isPackage: true,
    }
    // console.log('couponAdditionalParams',this.couponAdditionalParams)
  }

  public proceedApptFlow(data) {
    console.info('canpay', this.canPay, 'chargeDetails', this.chargeDetails,  )
    this.packageService.setValue('chargeDetails', this.chargeDetails)
    this.packageService.setValue('canPay', this.canPay);
    this.toggleState(data)
  }

  private getPackageCharges(state, forcePaymentWithCash: boolean = false) {
    let payload = {
      patientId: this.healthPkg.selectedPatient.uhid,
      facilityId: this.healthPkg.choosenFacility.facilityId,
      isBackgroundProcess: false,
      patientClass: 'EX',
      orderCatalogCode: this.healthPkg.selectedPackage.code,
      subServiceOrderCatalogCode: this.healthPkg.bookingForConcepts[0].code,
      locale: 'en',
      billingGroupId: null,
      insuranceFinDtls: null,
      // additional params
      clinicCode: this.selectedSlot?.slot?.clinicCode,
      date: this.selectedSlot?.slot?.date,
      time: this.selectedSlot?.slot?.slot,
      patientPersonId: this.healthPkg.selectedPatient.personid,
      personName: this.healthPkg.selectedPatient.personname,
      dob: moment(this.healthPkg.selectedPatient.dob).format('YYYY-MM-DD'),
      gender: this.healthPkg.selectedPatient.gender,
      patientName: this.healthPkg.selectedPatient.personname,
      resourceId: this.resourceId,
      practitionerId: this.healthPkg.selectedPract ? this.resourceId: null,
      resourceClass: this.resourceClass,
      resourceType: this.resourceClass,
      forcePaymentWithCash: forcePaymentWithCash,
      directiveCode: this.healthPkg.selectedDirective?.code || "HLTHPKGS",
      conceptCode: this.selectedPackage?.code,
      subserviceDirectiveCode: this.healthPkg.bookingForConcepts[0]?._directiveRef?.code,
      subServiceConceptCode: this.healthPkg.bookingForConcepts[0].code,
    }
    let subscribers = [this.packageService.getPackageCharges(payload)]
    // if (this.selectedVisitType === 'HOMECARE') {
    //   let addChargePayload = this.generateAddlChargeParams();
    //   subscribers.push(this.homecare.getHomeCareAddServiceCharge(addChargePayload));
    // }
    forkJoin(subscribers).subscribe((response) => {
      let data = response[0];
      let addChargeResponse;
      // if (response[1]) {
      //   addChargeResponse = response[1];
      //   this.homeCareAddlCharge = {
      //     name: addChargeResponse.homeCareAdditionalServiceChargeDesc,
      //     code: addChargeResponse.homeCareAdditionalServiceChargeCode,
      //     value: Number(addChargeResponse.homeCareAdditionalServiceCharge)
      //   }
      // }
      this.mapServiceResponse(data, state);
    })
  }

  private mapServiceResponse(data, state) {
    this.selectedServices = [
      {
        directiveCode: this.healthPkg?.selectedDirective?.['code'] || 'HLTHPKGS',
        conceptCode: this.selectedPackage?.['code'],
        details: {},
        selected: true
      }
    ]
    let totalPatientPayable = this.user.fixDecimalPlaces(Number(data.patientPayableAmount));
    let chargeArr = data.charge;
    let applicableService: any = data.discount;
    let discountApplicableService = applicableService.filter(service => {
      return service?.discountApplicable === 'Y'
    });

    let promoApplicableService = applicableService.filter(service => {
      return service?.promoDiscountApplicable === 'Y'
    });
    let pointsApplicableService = applicableService.filter(service => {
      return service?.pointsDiscountApplicable === 'Y'
    });

    const checkDiscountType = (services, code) => {
      return services.map(service => service.code).includes(code)
    }

    this.selectedPackage['discountApplicable'] = checkDiscountType(discountApplicableService, this.selectedPackage['code'])
    this.selectedPackage['promoDiscountApplicable'] = checkDiscountType(promoApplicableService, this.selectedPackage['code'])
    this.selectedPackage['pointsDiscountApplicable'] = checkDiscountType(pointsApplicableService, this.selectedPackage['code'])
    let concept = chargeArr.find((d) => d.code == this.selectedPackage['code']);
    this.selectedPackage['chargeStr'] = concept['chargeStr'];
    this.selectedPackage['servicecost'] = totalPatientPayable;
    this.selectedServices[0]['details']['discountApplicable'] = this.selectedPackage['discountApplicable'] ? 'Y': 'N';
    this.selectedServices[0]['details']['promoDiscountApplicable'] = this.selectedPackage['promoDiscountApplicable'];
    this.selectedServices[0]['details']['pointsDiscountApplicable'] = this.selectedPackage['pointsDiscountApplicable'];
    this.selectedServices[0]['details']['chargeStr'] = concept ? concept['chargeStr'] : '';
    this.selectedServices[0]['details']['servicecost'] = totalPatientPayable;
    this.selections = {
      facility: { id: this.healthPkg?.choosenFacility?.facilityId },
      practitioner: { id: this.resourceId },
      patient: { id: this.selectedPatient?.['uhid'] }
    }
    this.packageService.setValue('selections', this.selections);
    this.packageService.setValue('selectedServicesDtl', this.selectedServices);
    if (data['disableCoupon']) {
      let isEnableCoupon = false;
      this.packageService.setValue('isEnableCoupon', isEnableCoupon)
    }
    if (data['disablePoints'] || !this.selectedPackage['pointsDiscountApplicable']) {
      let isEnablePoints = false
      this.packageService.setValue('isEnablePoints', isEnablePoints)
    }
    if (data['disablePromo'] || !this.selectedPackage['promoDiscountApplicable']) {
      let isEnablePromo = false;
      this.packageService.setValue('isEnablePromo', isEnablePromo)
    }
    let additionalCharge = Number(0)
    let parsedCharges = chargeArr.map(charge => charge.parsedCharge)
    this.chargeVatInfo = _.cloneDeep(data.parsedCharges);
    if (parsedCharges && parsedCharges.length > 0) {
      this.chargeVatDetails = this.calculateVatcharges(data.parsedCharges)
      this.packageService.setValue('chargeVatDetails', this.chargeVatDetails)
    }
    this.chargeDetails = {
      discountDetails: { applicable: this.selectedPackage['promoDiscountApplicable'] || this.selectedPackage['pointsDiscountApplicable'], charge: concept['chargeStr'] },
      baseServiceCharge: this.chargeVatDetails.baseServiceAmount,
      vatAmount: this.chargeVatDetails.vatAmount,
      vatExemptAmount: this.chargeVatDetails.vatExemptAmount,
      consultationCharge: totalPatientPayable,
      totalAmount: totalPatientPayable,
      discountedPayable: totalPatientPayable,
      netPayable: totalPatientPayable,
      promoDiscount: 0,
      couponDiscount: 0,
      isPromoApplied: false,
      isCouponApplied: false,
      isFreeFollowUp: false,
      couponTitle: [],
      canPayOptional: false,
      additionalCharge: additionalCharge,
    }
    this.calculatePayable()
    this.proceedApptFlow(state)

    setTimeout(_ => {
      // console.log('can pay....', this.canPay);
    }, 500)
    // this.isApplyingCode = false;
    this.cdf.detectChanges();
  }
  private calculatePayable() {
    let couponDiscount = this.chargeDetails.couponDiscount || 0;
    let pointsDiscount = this.pointsType == 'PAYMENT' ? (this.chargeDetails.pointsDiscount || 0) : 0;
    let additionalCharge = Number(this.chargeDetails.additionalCharge) || 0
    this.chargeDetails.netPayable = this.chargeDetails.discountedPayable + additionalCharge - couponDiscount - pointsDiscount;
    this.chargeDetails.totalVat = this.calculateVatDisplayAmount(this.chargeDetails.vatAmount, this.chargeDetails.vatExemptAmount)
    this.chargeDetails._payableWithoutCoupon = this.chargeDetails.netPayable + couponDiscount;
    this.chargeDetails._payableWithoutPoints = this.chargeDetails.netPayable + pointsDiscount;
    this.resetPaymentFlow()
  }

    private resetPaymentFlow() {
    let canPay = true;
    if (Number(this.chargeDetails.netPayable) <= 0) {
      this.chargeDetails.netPayable = 0;
      canPay = false;
    }
    this.canPay = this.isPayableService && canPay;
    this.chargeDetails.netPayable = this.user.fixDecimalPlaces(Number(this.chargeDetails.netPayable));
    this.chargeDetails.yetToPay = Number(this.chargeDetails.netPayable) > 0
    this.chargeDetails = _.cloneDeep(this.chargeDetails)
    setTimeout(_ => {
      this.cdf.detectChanges()

    }, 500)
  }

    private calculateVatcharges(parsedCharges) {
    let baseAmount = 0, vatAmount = 0, vatExemptAmount = 0;
    parsedCharges.forEach(charge => {
      baseAmount = baseAmount + parseFloat(charge.baseServiceAmount);
      vatAmount = vatAmount + (charge.vatAmount ? parseFloat(charge.vatAmount) : 0);
      vatExemptAmount = vatExemptAmount + (charge.vatExemptedAmt ? parseFloat(charge.vatExemptedAmt) : 0);
    })
    const chargeVatDetails = {
      baseServiceAmount: baseAmount,
      vatAmount: vatAmount,
      vatExemptAmount: vatExemptAmount
    }
    chargeVatDetails['vatDisplayAmount'] = this.calculateVatDisplayAmount(chargeVatDetails.vatAmount, chargeVatDetails.vatExemptAmount);
    return chargeVatDetails
  }

  private calculateVatDisplayAmount(vatamt, vatexpamt) {
    let vatDisplayAmount;
    vatDisplayAmount = vatamt - vatexpamt;
    vatDisplayAmount = vatDisplayAmount.toString();
    return vatDisplayAmount;
  }

    public chooseConsultationType(): Promise<string | null> {
    this.openConsultationTypeSelection = true;

    return new Promise((resolve) => {
      this.consultResolve = resolve;
    });
  }

  public handleClose() {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(null);
  }

  public handleConfirm(consultType: string) {
    this.openConsultationTypeSelection = false;
    this.consultResolve?.(consultType);
  }

  get resourceId() {
    let resourceId=''
    if(this.healthPkg.selectedPract?.id){
      resourceId=this.healthPkg.selectedPract?.id
    }else if(this.healthPkg.choosenFacility?.controls?.packageCalendarResourceCode){
      let resources = this.healthPkg.choosenFacility.controls.packageCalendarResourceCode.split(',')
      if(resources.length==1)
      resourceId=resources[0] || this.healthPkg.choosenFacility.controls.packageCalendarResourceCode;
      else if(resources.length>1){
        resourceId=resources[0]
        if(this.healthPkg.rescheduleParams?.resourceId && resources.includes(this.healthPkg.rescheduleParams.resourceId)){
          resourceId=this.healthPkg.rescheduleParams.resourceId
        }
      }
    }else if(this.healthPkg.choosenFacility?.clinicCode){
      resourceId=this.healthPkg.choosenFacility.clinicCode
    }
    return resourceId
  }
  get resourceClass() {
    return this.healthPkg.selectedPract ? null : (this.healthPkg.choosenFacility?.controls?.packageCalendarResourceClass || this.healthPkg.choosenFacility?.resourceType)
  }

}
